<template>
    <div class="width100 float_l padding_t30 height193">
      <div class="width_1200 margin_auto">
        <div class="width100 float_l text_c border_t margin_t20 padding_t20 color_gray fon_siz12">
          <span>© 2025 实验室预约管理系统</span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name :'user-foot',
    data(){
      return {
      }
    },
    mounted(){
    },
    methods: {
      
    }
  }
</script>
